import { Component, Input } from '@angular/core';
import { IBookingDetails } from 'src/app/models/booking/bookingDetails';
import { SeatProfile } from 'src/app/models/enums';
import { images } from 'src/images';

@Component({
    selector: 'app-booking-seats',
    templateUrl: './booking-seats.component.html',
    styleUrl: './booking-seats.component.scss',
    standalone: false
})
export class BookingSeatsComponent {
  @Input() booking: IBookingDetails;

  public images = images;

  get regularSeatsCount(): number {
    return this.booking.bookingSeats?.filter(seat => seat.profile == SeatProfile.Regular && !seat.prm).length;
  }

  get prmSeatsCount(): number {
    return  this.booking.bookingSeats?.filter(seat => seat.profile == SeatProfile.Regular && seat.prm).length;
  }

  get minorSeatsCount(): number {
    return this.booking.bookingSeats?.filter(seat => seat.profile == SeatProfile.Minor).length;
  }

  get petSeatsCount(): number {
    return this.booking.bookingSeats?.filter(seat => seat.profile == SeatProfile.Pet).length;
  }

  get pregnantSeatsCount(): number {
    return this.booking.bookingSeats?.filter(seat => seat.profile == SeatProfile.Pregnant).length;
  }

  get dependantSeatsCount(): number {
    return this.booking.bookingSeats?.filter(seat => seat.profile == SeatProfile.Dependant).length;
  }

  get blindSeatsCount(): number {
    return this.booking.bookingSeats?.filter(seat => seat.profile == SeatProfile.Blind).length;
  }

  get deafSeatsCount(): number {
    return this.booking.bookingSeats?.filter(seat => seat.profile == SeatProfile.Deaf).length;
  }

  get particularSeats(): boolean {
    return this.booking.bookingSeats?.some(seat => seat.profile != SeatProfile.Regular || seat.name || seat.need);
  }
}
